import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {Action, Category, Entity} from '@vio/core/src/analytics/types/Events'

import type {useDispatchTeamEvent} from '@vio/core/src/analytics/components/TeamContext'

type TeamDispatch = ReturnType<typeof useDispatchTeamEvent>

export const trackDealFreezeToastDisplayed = (dispatch: TeamDispatch) => {
  dispatch(
    trackEvent({
      category: Category.System,
      entity: Entity.ToastMessage,
      action: Action.Displayed,
      payload: {component: 'DealFreezeToast', toastMessage: 'dealFreeze'}
    })
  )
}

export const trackFreezableFilterTooltipDisplayed = (
  dispatch: TeamDispatch
) => {
  dispatch(
    trackEvent({
      category: Category.System,
      entity: Entity.Tooltip,
      action: Action.Displayed,
      payload: {
        component: 'FreezableFilterExplanationTooltip',
        tooltipMessage: 'dealFreezeFilter'
      }
    })
  )
}
